import { SidePanel } from "components/designV2/sidePanel/sidePanel";
import { useCloseOnEscape } from "hooks/useCloseOnEscape";
import { useTranslation } from "react-i18next";
import type { TimeReportsGroupByOption } from "../toolbar/timeReportsToolbar.component";
import {
  HiddenRadio,
  RadioControl,
  RadioGroup,
  RadioLabel,
  RadioOption,
  Section,
  SectionDescription,
  SectionTitle,
} from "./timeReportsOptionsPanel.styled";

interface TimeReportsOptionsPanelProps {
  isOpen: boolean;
  groupByOption: TimeReportsGroupByOption;
  onGroupByChange: (value: TimeReportsGroupByOption) => void;
  onClose: () => void;
}

export const TimeReportsOptionsPanel = (
  props: TimeReportsOptionsPanelProps,
): JSX.Element | null => {
  const { t } = useTranslation();
  const isOpen = props.isOpen;
  const onClose = props.onClose;

  useCloseOnEscape({
    isOpen,
    onClose,
    stopPropagation: true,
  });

  return (
    <SidePanel
      isOpen={isOpen}
      onClose={onClose}
      title={t("TimeReports.Options")}
    >
      <Section>
        <SectionTitle>{t("TimeReports.GroupBy")}</SectionTitle>
        <SectionDescription>
          {t("TimeReports.GroupByDescription")}
        </SectionDescription>
        <RadioGroup role="radiogroup" aria-label={t("TimeReports.GroupBy")}>
          <RadioOption>
            <HiddenRadio
              type="radio"
              name="time-reports-group-by"
              checked={props.groupByOption === "team"}
              onChange={() => props.onGroupByChange("team")}
            />
            <RadioControl />
            <RadioLabel>{t("TimeReports.Team")}</RadioLabel>
          </RadioOption>
          <RadioOption>
            <HiddenRadio
              type="radio"
              name="time-reports-group-by"
              checked={props.groupByOption === "person"}
              onChange={() => props.onGroupByChange("person")}
            />
            <RadioControl />
            <RadioLabel>{t("TimeReports.Person")}</RadioLabel>
          </RadioOption>
        </RadioGroup>
      </Section>
    </SidePanel>
  );
};
